import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from "antd"
import { Label } from "reactstrap"

const { Option } = Select

class MultiSelect extends Component {

    state = {
        newValue: []
    }

    _handleChangeColor = (value) => {
        this.setState({ newValue: value })
    }

    _handleChangeValue = () => {
        const { field } = this.props
        // await this.typeSelect.blur()
        const { onChange } = this.props

        if (typeof onChange === 'function') {

            if (field === 'Brand Name') return onChange('brand_name', this.state.newValue)
            if (field === 'Tags') return onChange('list_tags', this.state.newValue)

            onChange('products.type', this.state.newValue)

        }
    }

    _handleChangeValues = (value) => {
        const { field } = this.props
        const { onChange } = this.props

        if (typeof onChange === 'function') {
            if (field === 'Brand Name') return onChange('brand_name', this.state.newValue.filter(item => item !== value))
            if (field === 'Tags') return onChange('list_tags', this.state.newValue.filter(item => item !== value))

            onChange('products.type', this.state.newValue.filter(item => item !== value))
        }
    }


    render() {
        const { lists, field, value } = this.props

        return (
            <div className="MultiSelect">
                <Label>{field}</Label>
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    defaultValue={value}
                    // ref={(select) => this.typeSelect = select}
                    onChange={this._handleChangeColor}
                    onBlur={this._handleChangeValue}
                    onDeselect={this._handleChangeValues}
                    className="selectScroll"
                >
                    {
                        lists.map(item => {
                            if (typeof item === 'object' && !!item) {
                                return <Option key={item.value} value={item.value}>{item.name}</Option>
                            }
                            return <Option key={item}>{item}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

MultiSelect.propTypes = {
    value: PropTypes.array,
    lists: PropTypes.array.isRequired,
    field: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default MultiSelect
